import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api/api';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './contractSign.css';

function ContractRenewal() {
  const { storeId, token } = useParams();
  const [loading, setLoading] = useState(true);
  const [expired, setExpired] = useState(false);
  const [storeData, setStoreData] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get(`/contract/renewal-verify/${storeId}/${token}`)
      .then(res => { setStoreData(res.data.store); setLoading(false); })
      .catch(() => { setExpired(true); setLoading(false); });
  }, [storeId, token]);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await api.post(`/contract/renewal-confirm/${storeId}/${token}`);
      setConfirmed(true);
    } catch (e) {
      alert('Renewal failed: ' + (e.response?.data?.message || e.message));
    }
    setSubmitting(false);
  };

  if (loading) return <div className="contract-sign-container"><p>Loading...</p></div>;
  if (expired) return (
    <div className="contract-sign-container">
      <div className="contract-card" style={{ textAlign: 'center', padding: 40 }}>
        <h2 style={{ color: '#e53935' }}>Link Expired</h2>
        <p>This renewal link has expired. Please contact Digntec for a new link.</p>
      </div>
    </div>
  );

  if (confirmed) return (
    <div className="contract-sign-container">
      <div className="contract-card" style={{ textAlign: 'center', padding: 40 }}>
        <CheckCircleIcon style={{ fontSize: 60, color: '#22c55e' }} />
        <h2 style={{ color: '#22c55e' }}>Renewal Confirmed!</h2>
        <p>Your Digital Signage Service Agreement for <strong>{storeData?.name}</strong> has been renewed for one year.</p>
        <p style={{ color: '#888', fontSize: 13 }}>Thank you for your continued partnership.</p>
      </div>
    </div>
  );

  return (
    <div className="contract-sign-container">
      <div className="contract-card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ color: '#551FFF', margin: 0 }}>Contract Renewal</h2>
          <p style={{ color: '#888', margin: '8px 0 0' }}>Digital Signage Service Agreement</p>
        </div>

        <div style={{ background: '#f8f7ff', borderRadius: 8, padding: 16, marginBottom: 20 }}>
          <p style={{ margin: '0 0 4px', fontWeight: 600 }}>Store: {storeData?.name}</p>
          <p style={{ margin: 0, color: '#555', fontSize: 14 }}>Owner: {storeData?.ownerName || '-'}</p>
          {storeData?.contractSignedAt && (
            <p style={{ margin: '4px 0 0', color: '#888', fontSize: 13 }}>
              Originally signed: {new Date(storeData.contractSignedAt).toLocaleDateString('en-US')}
            </p>
          )}
          <p style={{ margin: '4px 0 0', color: '#888', fontSize: 13 }}>
            Current version: v{storeData?.contractVersion || 1}
          </p>
        </div>

        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 8px', fontSize: 15 }}>Renewal Terms</h3>
          <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, lineHeight: 1.8, color: '#555' }}>
            <li>This Agreement will be renewed for an additional one (1) year term.</li>
            <li>All existing terms and conditions remain in effect.</li>
            <li>Monthly service fees continue at the current rate.</li>
            <li>Either party may terminate with 30 days written notice.</li>
          </ul>
          <p style={{ fontSize: 11, color: '#888', marginTop: 12 }}>
            All monetary amounts are denominated in United States Dollars (USD).
          </p>
        </div>

        <button
          onClick={handleConfirm}
          disabled={submitting}
          style={{
            width: '100%', padding: '14px 0', background: '#551FFF', color: 'white',
            border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer',
            opacity: submitting ? 0.6 : 1,
          }}>
          {submitting ? 'Processing...' : 'I Agree — Renew Contract'}
        </button>

        <p style={{ textAlign: 'center', fontSize: 11, color: '#aaa', marginTop: 16 }}>
          Digntec LLC · 15 Veterans Way, Edgewater, NJ 07020 · All amounts in USD
        </p>
      </div>
    </div>
  );
}

export default ContractRenewal;
